import React from "react";
import { Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const ImagePreviews = ({ posterPreviews, handleRemovePoster }) => {
  return (
    <Box>
      {posterPreviews.length > 0 && (
        <div>
          <h3>Image Previews</h3>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            {posterPreviews.map((preview, index) => (
              <div
                key={index}
                style={{
                  width: "120px",
                  textAlign: "center",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100px",
                    borderRadius: "5px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={preview.url}
                    alt="Poster preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
                <div
                  style={{
                    marginTop: "5px",
                    fontSize: "12px",
                    wordBreak: "break-word",
                  }}
                >
                  {preview.name}
                </div>
                <button
                  onClick={() => handleRemovePoster(index)}
                  style={{
                    position: "absolute",
                    top: "0",
                    right: "0",
                    border: "none",
                    backgroundColor: "rgba(255,0,0,0.6)",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                >
                  <DeleteIcon style={{ color: "white" }} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </Box>
  );
};

export default ImagePreviews;
